import React, { createContext, useContext, useState, useEffect, useLayoutEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {

    // Default to dark mode unless user explicitly selected light mode.
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'light' ? false : true;
    // Default is dark mode; only an explicit "light" preference enables light mode.
    try {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme === 'light') return false;
      return true;
    } catch (_) {
      return true;
    }
  });

  // Apply theme before paint to avoid flashing light mode on dashboard load.
  useLayoutEffect(() => {
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  useEffect(() => {
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
